
import React from 'react'
import {useEffect, useState} from 'react'
import { useGlobalStore } from '../../store/hooks/useStore'

import { KlarnaOSMContainerProps } from '../../types/cms/klarna-osm-container'
import { KlarnaOSM } from '../../components/klarna-osm/klarna-osm'

import {isServer} from '../../utils/utils'

export const KlarnaOSMContainer = ({content}: KlarnaOSMContainerProps) => {

	const klarnaIsLoaded = () => !isServer && window.Klarna !== undefined
	const {isKlarnaAvailable} = useGlobalStore();

	const [klarnaAvailable, setKlarnaAvailable] = useState(klarnaIsLoaded())

	/**	Check availability of Klarna base script and load on demand if needed */
	useEffect(() => {
		const loadKlarnaScript = async () => {
			const loaded = await isKlarnaAvailable()
			setKlarnaAvailable(loaded)
		}
		if(!klarnaIsLoaded()) {
			loadKlarnaScript()
		}
	}, [klarnaAvailable]);

	if (!content) {
    	return null
  	}

	return(
		<>
			<KlarnaOSM keyId={content.klarnaKey}/>
		</>
	)
}
